import { render, staticRenderFns } from "./JournalChapter.vue?vue&type=template&id=56bf68ba&"
import script from "./JournalChapter.vue?vue&type=script&lang=js&"
export * from "./JournalChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports